import React, { useState } from "react";
import DatePicker from "../datePicker/DatePicker";
import { DelayInput } from "react-delay-input/lib/Component";
import {
  getEndOfDayFromDate,
  getStartOfDayFromDate,
  TimestampToDate
} from "../../../utils/timestampToDate";
import DefaultButton from "../../styles/materialButtonStyle";
import { StyledDatepicker } from "../../styles/styledDatepicker";
import Dropdown from "rc-dropdown";
import { useTranslation } from "react-i18next";
import MappedServicesFilter from "../serviceReletionships/mappedServices/MappedServicesFilter";

import {
  StyledFilterBlock,
  StyledFilterBlockTitle,
  StyledFilterCloseBtn,
  StyledFilterDropdownWrapper,
  StyledFilterGroup,
  StyledFilterWrapper,
  StyledShowFilterBtn
} from "../filter/styledFiter";
import TransactionTypeSelect from "../transactions/TransactionTypeSelect";

const MasterRefillingsFilter = ({
  filterData,
  setFilterData
}) => {
  const { t } = useTranslation("cashFlow");

  const DEFAULT_FILTER_DATA = {
    "page": 1,
    "service.name": null,
    "currency.asset": null,
    "type": null,
    "createdAt[gte]": null,
    "createdAt[lte]": null,
    "amount[gte]": "",
    "amount[lte]": "",
    "user.email": "",
    "id": "",
    "itemsPerPage": filterData["itemsPerPage"] ?? null
  };

  const [visible, setVisible] = useState(false);

  const onVisibleChange = (visible) => {
    setVisible(visible);
  };

  const handleClearFilter = () => {
    setFilterData(DEFAULT_FILTER_DATA);
  };

  const handleChangeFilterData = (data, name) => {
    setFilterData(prev => ({
      ...prev,
      [name]: data,
      page: 1
    }))
  };

  const FilterList = () => {
    return (
      <>
        {visible &&
          <StyledFilterDropdownWrapper>
            <StyledFilterBlock actions>
              <StyledFilterGroup className="clear-btn">
                <DefaultButton
                  color="transparent"
                  onClick={handleClearFilter}
                >
                  {t("transactions.filter.clearBtn")}
                </DefaultButton>
              </StyledFilterGroup>
              <StyledFilterGroup className="close-btn">
                <StyledFilterCloseBtn onClick={() => setVisible(false)} />
              </StyledFilterGroup>
            </StyledFilterBlock>
            <StyledFilterBlockTitle>
              {t("transactions.filter.filterBy")}:
            </StyledFilterBlockTitle>
            <StyledFilterBlock>
              <MappedServicesFilter
                checkedService={filterData["masterBalance.service.name"]}
                setCheckedService={data => handleChangeFilterData(data, "masterBalance.service.name")}

                checkedCurrency={filterData["masterBalance.currency.asset"]}
                setCheckedCurrency={data => handleChangeFilterData(data, "masterBalance.currency.asset")}

                withPaymentSystem={false}
              />
              <TransactionTypeSelect
                checkedStatus={filterData["type"]}
                setCheckedStatus={(value) => setFilterData({
                  ...filterData,
                  "type": value,
                  page: 1
                })}
              />
            </StyledFilterBlock>
            <StyledFilterBlock>
              <StyledFilterGroup>
                <label htmlFor="user">
                  {t("balancesHistory.filter.user")}
                </label>
                <DelayInput
                  id="user"
                  delayTimeout={2000}
                  onChange={event => setFilterData({ ...filterData, "user.email": event.target.value, page: 1 })}
                  name="user"
                  value={filterData["user.email"]}
                  type="text"
                />
              </StyledFilterGroup>
              <StyledFilterGroup>
                <label htmlFor="id">
                  ID
                </label>
                <DelayInput
                  id="id"
                  delayTimeout={2000}
                  onChange={event => setFilterData({ ...filterData, "id": event.target.value, page: 1 })}
                  name="id"
                  value={filterData["id"]}
                  type="text"
                />
              </StyledFilterGroup>
            </StyledFilterBlock>
            <StyledFilterBlockTitle>
              {t("transactions.filter.amount")}:
            </StyledFilterBlockTitle>
            <StyledFilterBlock>
              <StyledFilterGroup>
                <label htmlFor="amount[gte]">
                  {t("transactions.filter.amountFrom")}
                </label>
                <DelayInput
                  id="amount[gte]"
                  delayTimeout={2000}
                  onChange={event => setFilterData({
                    ...filterData,
                    "amount[gte]": event.target.value,
                    page: 1
                  })}
                  name="amount[gte]"
                  value={filterData["amount[gte]"]}
                  type="number"
                  placeholder={t("transactions.filter.amountFromPlaceholder")}
                />
              </StyledFilterGroup>
              <StyledFilterGroup>
                <label htmlFor="amount[lte]">
                  {t("transactions.filter.amountTo")}
                </label>
                <DelayInput
                  id="amount[lte]"
                  delayTimeout={2000}
                  onChange={event => setFilterData({
                    ...filterData,
                    "amount[lte]": event.target.value,
                    page: 1
                  })}
                  name="amount[lte]"
                  value={filterData["amount[lte]"]}
                  type="number"
                  placeholder={t("transactions.filter.amountToPlaceholder")}
                />
              </StyledFilterGroup>
            </StyledFilterBlock>
            <StyledFilterBlockTitle>
              {t("transactions.filter.date")}:
            </StyledFilterBlockTitle>
            <StyledFilterBlock col="2">
              <StyledDatepicker>
                <label htmlFor="dateFrom">
                  {t("transactions.filter.dateFrom")}
                </label>
                <DatePicker
                  format="dd-MM-y"
                  id="dateFrom"
                  name="dateFrom"
                  className="date-input"
                  onChange={dateFrom => setFilterData({
                    ...filterData,
                    "createdAt[gte]": getStartOfDayFromDate(dateFrom),
                    page: 1
                  })}
                  value={TimestampToDate(filterData["createdAt[gte]"])}
                />
              </StyledDatepicker>
              <StyledDatepicker>
                <label htmlFor="dateTo">
                  {t("transactions.filter.dateTo")}
                </label>
                <DatePicker
                  format="dd-MM-y"
                  id="dateTo"
                  name="dateTo"
                  className="date-input"
                  onChange={dateTo => setFilterData({
                    ...filterData,
                    "createdAt[lte]": getEndOfDayFromDate(dateTo),
                    page: 1
                  })}
                  value={TimestampToDate(filterData["createdAt[lte]"])}
                />
              </StyledDatepicker>
            </StyledFilterBlock>
          </StyledFilterDropdownWrapper>}
      </>
    );
  };

  return (
    <StyledFilterWrapper id="filter">
      <Dropdown
        getPopupContainer={() => document.getElementById("filter")}
        overlay={FilterList}
        trigger={["click"]}
        placement="bottomLeft"
        align={{ overflow: { adjustX: true, adjustY: false } }}
        onVisibleChange={onVisibleChange}
        visible={visible}
        closeOnSelect={false}
      >
        <StyledShowFilterBtn>
          <DefaultButton
            color="success"
          >
            {t("transactions.filter.filterBtn")}
          </DefaultButton>
        </StyledShowFilterBtn>
      </Dropdown>
    </StyledFilterWrapper>
  );
};

export default MasterRefillingsFilter;